/**
 * ContactMailSection
 *
 * Section 2 of the Contact page: a "Contact us by mail" label above the
 * selectable `support@expause.com` address. The `userSelect: 'text'` wrapper
 * is the web equivalent of Flutter's `SelectionArea`.
 *
 * Co-located with `ContactPage` to keep the page under the ~200-line
 * Should-Fix threshold from `presentation.md`.
 */
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { qaAttr } from '@/presentation/utils/qaAttr';

export const ContactMailSection = () => {
    const { theme } = useTheme();
    const responsive = useResponsiveDesign();
    const { l10n } = useLocale();

    return (
        <section
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <p
                style={{
                    margin: 0,
                    marginBottom: responsive.spacing.sm,
                    color: theme.text.primary,
                    fontSize: responsive.font.base,
                    fontWeight: responsive.fontWeight.semibold,
                    textAlign: 'center',
                }}
            >
                {l10n.contact.mailSectionLabel}
            </p>
            <span
                {...qaAttr({ id: 'contact-mail', value: l10n.contact.mailAddress })}
                style={{
                    userSelect: 'text',
                    color: theme.text.primary,
                    fontSize: responsive.font.base,
                    textAlign: 'center',
                }}
            >
                {l10n.contact.mailAddress}
            </span>
        </section>
    );
};
